import * as React from 'react';
import { Box } from '@mui/material';
import Loading from '../../../../auxiliares/loading';
import MarkerDetail from './markerDetail';
import { options } from '@config';


const ItemTableContainer = () => {
    const [items, setItems] = React.useState<any[]>([]);
    const [loading, setLoading] = React.useState(true);
  
    const handleListPoints = async () => {
      const response = await fetch(options.api.url + "point", {
        method: "GET",
        mode: "cors",
        headers: { "Content-Type": "application/json" },
      });
      const data = await response.json();
      return data.pointsSearched ?? [];
    };
  
    React.useEffect(() => {
      (async () => {
        try {
          const res = await handleListPoints();
          setItems(res);
        } finally {
          setLoading(false);
        }
      })();
    }, []); // <-- solo una vez
  
    return <Box>{loading ? <Loading /> : <MarkerDetail items={items} />}</Box>;
  };
  

export default ItemTableContainer;